var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.199,
    height: 28.023,
    viewBox: "0 0 28.199 28.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-line",
    transform: "translate(-8.471 -8.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32044",
    "data-name": "Path 32044",
    d: "M21.7,30.7,18.8,33.572a4.7,4.7,0,0,1-6.609,0,4.61,4.61,0,0,1,0-6.527l5.515-5.468a4.7,4.7,0,0,1,6.609,0,4.539,4.539,0,0,1,1.176,2.011,2.352,2.352,0,0,0,.318-.318l1.517-1.505a6.926,6.926,0,0,0-1.352-1.905,7.056,7.056,0,0,0-9.925,0l-5.527,5.515a6.95,6.95,0,0,0,0,9.866,7.056,7.056,0,0,0,9.925,0l4.292-4.257h-.588A9.407,9.407,0,0,1,21.7,30.7Z",
    transform: "translate(0 -1.146)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32045",
    "data-name": "Path 32045",
    d: "M35.9,10.154a7.056,7.056,0,0,0-9.925,0l-4.292,4.257h.576a9.408,9.408,0,0,1,2.469.329l2.893-2.869a4.7,4.7,0,0,1,6.609,0,4.61,4.61,0,0,1,0,6.527l-5.515,5.468a4.7,4.7,0,0,1-6.609,0,4.539,4.539,0,0,1-1.176-2.011,2.352,2.352,0,0,0-.329.27L19.08,23.63a6.926,6.926,0,0,0,1.352,1.905,7.056,7.056,0,0,0,9.925,0l5.515-5.468a6.962,6.962,0,0,0,0-9.866Z",
    transform: "translate(-1.252)",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcLink);
export default __webpack_public_path__ + "static/media/vc-link.563614bbf962555c6d817d5792e4908c.svg";
export { ForwardRef as ReactComponent };